/**
 * InboxBadge — the app-bar inbox button with an unread count.
 *
 * Reads the SAME cached {@link ListInboxResponse} as the inbox grid (via
 * {@link useInbox}), so the badge count always matches what the grid shows
 * (mark-read / dismiss update both at once). Links to /inbox.
 */
import InboxIcon from "@mui/icons-material/Inbox";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import { Link } from "@tanstack/react-router";
import { useInbox } from "./hooks/useInbox";
import type { ReactElement } from "react";

export function InboxBadge(): ReactElement {
  const { data } = useInbox();
  const unread = data?.unreadCount ?? 0;

  return (
    <IconButton
      component={Link}
      to="/inbox"
      color="inherit"
      aria-label={
        unread > 0 ? `Inbox, ${unread} unread notifications` : "Inbox, no unread notifications"
      }
    >
      <Badge badgeContent={unread} color="error" aria-hidden>
        <InboxIcon />
      </Badge>
    </IconButton>
  );
}
